/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

import {DEFAULT_SITE_TITLE} from '@salesforce/retail-react-app/app/constants';

const Seo = ({title, description, noIndex, keywords, children, ...props}) => {
  const fullTitle = title ? `${title} | ${DEFAULT_SITE_TITLE}` : DEFAULT_SITE_TITLE;

  return (
    <Helmet {...props}>
      <title>{fullTitle}</title>
      {description && <meta content={description} name="description" />}
      {noIndex && <meta content="noindex" name="robots" />}
      {keywords && <meta content={keywords} name="keywords" />}
      {children}
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  noIndex: PropTypes.bool,
  children: PropTypes.node,
  keywords: PropTypes.string,
};

export default Seo;
